import { useQuery } from '@tanstack/react-query';
import type { CursorPage, ForecastScenarioRow } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useForecastScenarios(forecastId: string) {
  return useQuery({
    queryKey: ['forecast-scenarios', forecastId],
    queryFn: () =>
      apiGet<CursorPage<ForecastScenarioRow>>(`/v1/forecasts/${forecastId}/scenarios`),
    enabled: Boolean(forecastId),
    refetchInterval: 5000,
  });
}

export function useForecastSensitivities(forecastId: string) {
  return useQuery({
    queryKey: ['forecast-sensitivities', forecastId],
    queryFn: () =>
      apiGet<CursorPage<unknown>>(`/v1/forecasts/${forecastId}/sensitivities`),
    enabled: Boolean(forecastId),
    refetchInterval: 5000,
  });
}
